import "../../assets/css/myProfile/myProfile.css"

import addProfilePhoto from "../../assets/images/uploadPicture.svg"
import starRating from "../../assets/images/starRating.svg"
import save from "../../assets/images/save.svg"
import cvpBadge from "../../assets/images/CVPBagdeProfile.png"

import { useEffect, useState } from "react"
import { Modal, Tab, Tabs } from "react-bootstrap"

import InformationCompliance from "../tabs/informationCompliance.jsx";
import InformationComplianceFirstTime from "../tabsFirstTime/informationComplianceFirstTime.jsx";
import DocumentComplianceTable from "../tabs/documentCompliance/documentComplianceTable.jsx"
import QualitySurvey from "../tabs/qualitySurvey.jsx";
import QualitySurveyFirstTime from "../tabsFirstTime/qualitySurveyFirstTime.jsx";
import ProductsAndServices from "../tabs/productAndService.jsx"
import { checkInformationCompliance } from "../../utilities/utils.js"
import WarehousesTab from "../tabs/warehousesTab/warehousesTab.jsx"
import ProductAssignment from "../tabs/productAssignment/productAssignment.jsx"
import StaffList from "../tabs/staff/staffList.jsx"
import AddClientUserModal from "../clientsAdminView/addClientUserModal.jsx"
import addIcon from "../../assets/images/add.svg"
import UsersTab from "../suppliers/UsersTab.jsx"
import { useAuth } from "../../context/auth-user.jsx"
import PurchaseOrders from "../tabs/supplierPurchaseOrders/PurchaseOrders.jsx"
import { useMyProfileData, useMyProfileMutations } from "./hooks"

// MODAL TO SHOW THE CLIENT LIST
function SupplierClientsModalMyProfile(props) {
	return (
		<Modal
			className="supplierClientsModalMyProfile"
			size="lg"
			centered
			show={props.show}
			onHide={props.onHide}
		>
			<Modal.Body>
				<h4 className="commentTitle">Clients</h4>
				<table className="tableClients">
					<thead>
						<tr>
							<th><span>Name</span></th>
							<th><span>Status</span></th>
							<th><span>Actions</span></th>
						</tr>
					</thead>
					<tbody>
						{props.supplierClients.map((supplierClient, index) => (
							<tr key={index}>
								<td>
									<div className="infoContainer">
										<span>{props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
									</div>
								</td>
								<td>
									<div className="infoContainer">
										<span className={`${supplierClient.status === "Ready for review" ? "success" : ""} ${supplierClient.status === "Pre-authorized" || supplierClient.status === "Review requested" ? "pending" : ""} ${supplierClient.status === "New request" ? "new" : ""}`}>
											{supplierClient.status}
										</span>
									</div>
								</td>
								<td>
									<div className="infoContainer">
										<span className="actions">
											{
												(supplierClient.status === "Review requested") ?
													<button className="btnBgBlueTextGradient" onClick={() => props.readyForReview(supplierClient.clientID)}>
														Ready for review
													</button> :
													"No actions required"
											}
										</span>
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>

				<div className="d-lg-none mobileCientList">
					{props.supplierClients.map((supplierClient, index) => (
						<div key={index} className="clientRow">
							<span className="clientHeaderTitle">{props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
							<span className={`clientValue ${(() => {
								switch (supplierClient.status) {
									case "Active":
									case "Ready for review":
										return "success"

									case "Pre-authorized":
									case "Review requested":
										return "pending"

									case "New request":
										return "new"

									case "Rejected":
										return "failed"

									default:
										break;
								}
							})()}`}>
								{supplierClient.status}
							</span>
							<span className="clientTitle">Status</span>
							<span className="clientValue">
								{
									(supplierClient.status === "Review requested") ?
										<button className="btnBgBlueTextGradient" onClick={() => props.readyForReview(supplierClient.clientID)}>
											Ready for review
										</button> :
										"No actions required"
								}
							</span>
							<span className="clientTitle">Action</span>
						</div>
					))}
				</div>

				<div className="actionButton">
					<button className="btnBgBlueTextGradient" onClick={props.onHide}>Close</button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

// MODAL TO SHOW ALL THE SUPPLIER INDUSTRIES
function SupplierIndustriesModalMyProfile(props) {
	const { show, onHide, supplierIndustries } = props
	return (
		<Modal
			className="supplierIndustriesModalMyProfile"
			size="lg"
			centered
			show={show}
			onHide={onHide}
		>
			<Modal.Body>
				<h4 className="commentTitle">Industries</h4>

				<div className="industriesContainer">
					{supplierIndustries.map((industry, index) => (
						<span key={index} className="industry">{industry}</span>
					))}
				</div>

				<div className="actionButton">
					<button className="btnBgBlueTextGradient" onClick={onHide}>Close</button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default function MyProfile({ darkLightMode }) {
	// VARIABLES TO MANAGE THE USER LOGGED
	const { user } = useAuth()
	const userLogged = user?.selectedProfile

	const { supplierData, serverDate, clients, users: usersData } = useMyProfileData({ userLogged })
	const { handleSaveChanges, handleReadyForReview } = useMyProfileMutations({ userLogged })

	// VARIABLE TO MANAGE SUPPLIER INFO
	const [supplier, setSupplier] = useState(null);

	// VARIABLE TO MANAGE THE SELECTED TAB
	const [key, setKey] = useState(() => {
		if (userLogged?.rol === "Document manager") return "Document compliance"

		if (userLogged?.rol === "Product manager") return "Products/Services"

		return 'Information Completed'
	});

	// VARIABLE TO SHOW THE CLIENTS MODAL
	const [showClientsModal, setShowClientsModal] = useState(false)

	// VARIABLE TO SHOW THE INDUSTRIES MODAL
	const [showIndustriesModal, setShowIndustriesModal] = useState(false)

	const [showAddUserModal, setShowAddUserModal] = useState(false)

	// VARIABLES TO CONTROL THE PERCERT COMPLETED FOR THE TABS
	const [informationCompliancePercent, setInformationCompliancePercent] = useState(0)
	const [documentCompliancePercent, setDocumentCompliancePercent] = useState(0)
	const [historicDocumentCompliancePercent, setHistoricDocumentCompliancePercent] = useState(0)

	const [users, setUsers] = useState([])

	useEffect(() => { if (supplierData) setSupplier(supplierData) }, [supplierData])
	useEffect(() => { if (usersData) setUsers(usersData) }, [usersData])

	useEffect(() => {
		if (!supplier || !serverDate) return
		setInformationCompliancePercent(checkInformationCompliance(supplier.informationCompliance))
		setDocumentCompliancePercent(supplier.documentCompliancePercent ?? 0)
		setHistoricDocumentCompliancePercent(supplier.historicDocumentCompliancePercent ?? 0)
		supplier.informationCompliance.generalInformation.hasRepse && evaluateStaffCompliancy()
	}, [supplier, serverDate])

	useEffect(() => {
		supplier && supplier.informationCompliance.generalInformation.hasRepse && serverDate && evaluateStaffCompliancy()
	}, [key])







	// FUNCTION TO HANDLE DE PROFILE PICTURE CHANGE
	const handleProfilePictureChange = (element) => {
		if (element.files[0].name) {
			const supplierClone = { ...supplier }

			supplierClone.informationCompliance.generalInformation.profilePhoto.document = element.files[0]

			handleSaveChanges(supplierClone)
		}
	}

	// FUNCTION TO EVALUATE IF THE STAFF IS COMPLIANT AND CHANGE THE STAFF TAB
	const evaluateStaffCompliancy = () => {
		const element = document.getElementById("controlled-tab-example-tab-Staff List")

		const copySupplier = JSON.parse(JSON.stringify(supplier))

		const supplierList = copySupplier.staffs.filter(staff => staff.active && !staff.payrollReceipts.some(receipt => receipt.monthCreatedAt === serverDate.month && receipt.yearCreatedAt === serverDate.year))

		if (supplierList.length > 0) {
			element.classList.add("nonCompliant")
		} else {
			element.classList.remove("nonCompliant")
		}
	}

	return (
		<section className={`myProfile ${supplier?.firstTime ? "firstTime" : ""} ${darkLightMode ? "darkMode" : null}`}>
			<div className="header">
				{supplier?.firstTime ? (
					<>
						<div className="profilePhotoContainer">
							<input className="inputProfilePhoto" type="file" onChange={(e) => handleProfilePictureChange(e.target)} />
							<img className="profilePhoto" src={
								supplier.informationCompliance.generalInformation.profilePhoto.document && !supplier.informationCompliance.generalInformation.profilePhoto.document.name
									? process.env.REACT_APP_URI_UPLOADS + supplier.informationCompliance.generalInformation.rfc + "/" + supplier.informationCompliance.generalInformation.profilePhoto.document
									: addProfilePhoto
							} alt="Prodensa Supplier" />
						</div>
						<div className="titleLocation">
							<h3>{supplier.informationCompliance.generalInformation.companyName}</h3>
							<span>
								{`${supplier.informationCompliance.generalInformation.contactInformation?.name},
								${supplier.informationCompliance.generalInformation.address.city},
								${supplier.informationCompliance.generalInformation.address.state}`}
							</span>
						</div>
					</>
				) : (
					<>
						<div className="generalInformation">
							<div className="headInformation">
								<div className="profilePhotoContainer">
									<input className="inputProfilePhoto" type="file" onChange={(e) => handleProfilePictureChange(e.target)} />
									<img className="profilePhoto" src={
										supplier && supplier.informationCompliance.generalInformation.profilePhoto.document && !supplier.informationCompliance.generalInformation.profilePhoto.document.name
											? process.env.REACT_APP_URI_UPLOADS + supplier.informationCompliance.generalInformation.rfc + "/" + supplier.informationCompliance.generalInformation.profilePhoto.document
											: addProfilePhoto
									} alt="Prodensa Supplier" />
								</div>
								<h3>
									{supplier && supplier.informationCompliance.generalInformation.companyName}
									<span>All time document compliant: {historicDocumentCompliancePercent}%</span>

								</h3>
								<h4 className="ratingValue">
									{supplier && supplier.rating ? supplier.rating.$numberDecimal : "Unrated"}
									{supplier && supplier.rating && supplier.rating.$numberDecimal ? <img className="ratingImg" src={starRating} alt="Prodensa Supplier" /> : undefined}
								</h4>
							</div>
							<div className="industriesInformation">
								<div className="industriesContainer">
									{supplier && supplier.informationCompliance.facilitiesCapabilities.categories.map((category, index) => (
										index < 4 && <span key={index}>{category}</span>
									))}
								</div>
								{supplier && supplier.informationCompliance.facilitiesCapabilities.categories.length > 3 && <button className="btnBgBlueTextGradient" onClick={() => setShowIndustriesModal(true)}>
									See all ({supplier && supplier.informationCompliance.facilitiesCapabilities.categories.length})
								</button>}
							</div>
							<p className="description">{supplier && supplier.informationCompliance.facilitiesCapabilities.description}</p>
							<button className="btnBgBlueTextGradient" onClick={() => setShowClientsModal(true)}>
								View clients
							</button>
						</div>

						<div className="contactInformation">
							{supplier && supplier.informationCompliance.generalInformation.cvp.certified && <img className="cvpBadge" src={cvpBadge} alt="Prodensa Supplier" />}
							<div className="info">
								<span className="infoTitle">Address</span>
								<span className="infoText">
									{supplier && supplier.informationCompliance.generalInformation.address.streetAndNumber}<br />
									C.P. {supplier && supplier.informationCompliance.generalInformation.address.zipCode}<br />
									{supplier && supplier.informationCompliance.generalInformation.address.city + " " + supplier.informationCompliance.generalInformation.address.state}

								</span>
							</div>
							<div className="info">
								<span className="infoTitle">Contact information</span>
								<span className="infoText">
									{supplier && supplier.informationCompliance.generalInformation.contactInformation?.name}<br />
									{supplier && supplier.informationCompliance.generalInformation.contactInformation?.email}<br />
									{supplier && supplier.informationCompliance.generalInformation.contactInformation?.phone}
								</span>
							</div>
							<div className="info">
								<span className="infoTitle">Website</span>
								<span className="infoText">{supplier && supplier.informationCompliance.generalInformation.website}</span>
							</div>
						</div>
						<button className="btnBgBlueTextGradient d-lg-none" onClick={() => setShowClientsModal(true)}>
							View clients
						</button>
					</>
				)}
			</div>

			<div className="tabs-container">
				<Tabs
					className={`${darkLightMode ? "darkMode" : null}`}
					id="controlled-tab-example"
					activeKey={key}
					onSelect={(k) => setKey(k)}
				>
					{userLogged?.rol === "Supplier" && <Tab eventKey="Information Completed" title={`1 Information Completed (${informationCompliancePercent}%)`}>
						{supplier && serverDate && (supplier?.firstTime
							? <InformationComplianceFirstTime
								informationCompliance={supplier.informationCompliance}
								setSupplier={setSupplier}
								username={userLogged && userLogged.username}
								serverDate={serverDate}
							/>
							: <InformationCompliance
								informationCompliance={supplier.informationCompliance}
								setSupplier={setSupplier}
								username={userLogged && userLogged.username}
								serverDate={serverDate}
							/>
						)}
					</Tab>}
					{userLogged?.rol !== "Product manager" && <Tab eventKey="Document compliance" title={`2 Document compliance (${documentCompliancePercent}%)`}>
						{supplier && <DocumentComplianceTable
							supplier={supplier}
							setSupplier={setSupplier}
							serverDate={serverDate}
							handleSaveChanges={handleSaveChanges}
							complianceSetup={supplier?.firstTime}
							userLogged={userLogged}
							darkLightMode={darkLightMode}
						/>}
					</Tab>}
					{supplier?.informationCompliance?.generalInformation?.hasRepse && userLogged?.rol !== "Product manager" && (
						<Tab eventKey="Staff List" title="3 Staff">
							{supplier && <StaffList
								supplier={supplier}
							/>}
						</Tab>
					)}
					{userLogged?.rol !== "Product manager" && <Tab eventKey="Quality Survey" title="4 Quality Survey">
						{supplier && (supplier?.firstTime
							? <QualitySurveyFirstTime
								supplier={supplier}
								qualitySurvey={supplier.qualitySurvey}
								setSupplier={setSupplier}
								rfc={supplier.informationCompliance.generalInformation.rfc}
								handleSaveChanges={handleSaveChanges}
							/>
							: <QualitySurvey
								qualitySurvey={supplier.qualitySurvey}
								setSupplier={setSupplier}
								rfc={supplier.informationCompliance.generalInformation.rfc}
							/>
						)}
					</Tab>}
					{userLogged?.rol !== "Document manager" && <Tab eventKey="Products/Services" title="5 Products/Services">
						{supplier && serverDate && <ProductsAndServices
							darkLightMode={darkLightMode}
							supplier={supplier}
							productsAndServices={supplier.productsAndServices}
							setSupplier={setSupplier}
							serverDate={serverDate}
							userLogged={userLogged}
							rfc={supplier.informationCompliance.generalInformation.rfc}
							firstTime={supplier?.firstTime}
							handleSaveChanges={handleSaveChanges}
						/>}
					</Tab>}
					{!supplier?.firstTime && userLogged?.rol !== "Document manager" && <Tab eventKey="Warehouses" title="6 Warehouses">
						{supplier && serverDate && <WarehousesTab
							darkLightMode={darkLightMode}
							supplier={supplier}
							supplierProducts={supplier.productsAndServices.products}
							supplierWarehouses={supplier.warehouses}
							setSupplier={setSupplier}
							handleSaveChanges={handleSaveChanges}
						/>}
					</Tab>}
					{!supplier?.firstTime && userLogged?.rol !== "Document manager" && <Tab eventKey="Products Assignation" title="7 Product Assignment">
						{supplier && serverDate && <ProductAssignment
							supplier={supplier}
							supplierProducts={supplier.productsAndServices.products}
							supplierWarehouses={supplier.warehouses}
							setSupplier={setSupplier}
							handleSaveChanges={handleSaveChanges}
						/>}
					</Tab>}
					{!supplier?.firstTime && userLogged?.rol !== "Document manager" && <Tab eventKey="Purchase Orders" title="8 Purchase Orders">
						{supplier && serverDate && <PurchaseOrders
							activeMainTab={key}
							supplier={supplier}

						/>}
					</Tab>}
					{supplier && userLogged?.rol === "Supplier" && <Tab eventKey="users" title="9 Users">
						<UsersTab
							users={users}
							setUsers={setUsers}
							supplierId={userLogged.dataID}
						/>
					</Tab>}
				</Tabs>

				{(userLogged?.rol === "Supplier") && <button className="btnBgBlueTextGradient addUserButton"
					onClick={() => setShowAddUserModal(true)}
				>
					<img src={addIcon} alt="Prodensa Supplier" />
					Add user
				</button>}
			</div>

			{key !== "Document compliance" && <div className="actionButtons">
				<button className="btnBgBlueTextGradient" onClick={() => handleSaveChanges(supplier)}>{supplier?.firstTime ? "Save draft" : "Save changes"}</button>
			</div>}

			<button className="saveChanges" onClick={() => handleSaveChanges(supplier)}>
				<img src={save} alt="Prodensa Supplier" />
			</button>

			{supplier && clients && <SupplierClientsModalMyProfile
				supplierClients={supplier.clients}
				clients={clients}
				show={showClientsModal}
				onHide={() => setShowClientsModal(false)}
				readyForReview={(clientID) => handleReadyForReview(clientID)}
			/>}

			{supplier && <SupplierIndustriesModalMyProfile
				supplierIndustries={supplier.informationCompliance.facilitiesCapabilities.categories}
				show={showIndustriesModal}
				onHide={() => setShowIndustriesModal(false)}
			/>}

			{supplier && <AddClientUserModal
				darkLightMode={darkLightMode}
				show={showAddUserModal}
				onHide={() => setShowAddUserModal(false)}
				client={supplier}
				setUsers={setUsers}
			/>}
		</section>
	)
}